import { useEffect } from "react"
import { Button, Col, Modal, Row } from "react-bootstrap"
import styles from '../../../styles/modelo.module.css'

export default function NfseModalModelos ({ show, handleClose, empresa, modelos, handleModelo }:iPropsModal) {
    useEffect(() => {
    }, [])

    const modelosEmpresa:any[] = modelos.filter(reg => reg.id_empresa.id_empresa === empresa.id_empresa)
    const modelosEmpresaAtivos:any[] = modelosEmpresa.filter(reg => reg.situacao === 1)

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={true}
            size="xl"
            id="modal_nf_modelos"
        >
            <Modal.Header closeButton>
                <Modal.Title>Selecione um modelo:</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { (modelos.filter(reg => reg.id_empresa.id_empresa === empresa.id_empresa).length === 0) && <p>Não há modelos cadastrados na empresa selecionada.</p> }
                { modelosEmpresaAtivos.map((reg:any, idx: any) => {

                    let clienteNome:string = reg.id_cliente.nome
                    if (clienteNome.length > 45) {
                        clienteNome = `${clienteNome.substring(0, 45)}...`
                    }
                    const situacao_tributos: string = reg.trib_iss_ret === 2 ? "Retido" : "Tributado"
                    
                    return (
                        <div key={idx} className={styles.modeloLista} onClick={() => { handleModelo(reg) }}>
                            <p style={{fontWeight: "bold"}}>{reg.nome} {reg.id_modelo} {reg.tipo === 1 ? "(Mensal)" : "(Apenas Modelo)"}</p>
                            <p>Cliente: {clienteNome} {reg.id_cliente.tipo === 'PJ' ? `CNPJ ${reg.id_cliente.cnpj}` : `CPF ${reg.id_cliente.cpf}`}</p>
                            {/* {reg.cod_serv.iss_incidencia_municipio_prestador === 1 ? "Retido" : "Tributado"} */}
                            <p>Serviço: {situacao_tributos} | {reg.servico_cod} {reg.servico_descricao}</p>
                            <br></br>
                            <p>Valor: R$ {reg.valor_servicos}</p>
                            <br></br>
                            <Row>
                                <Col className="col-2">IRRF <br></br>{reg.IRRF} <br></br> {reg.IRRF_V}</Col>
                                <Col className="col-2">INSS <br></br>{reg.CP} <br></br> {reg.CP_V}</Col>
                                <Col className="col-2">COFINS <br></br>{reg.COFINS} <br></br> {reg.COFINS_V}</Col>
                                <Col className="col-2">CSLL <br></br>{reg.CSLL} <br></br> {reg.CSLL_V}</Col>
                                <Col className="col-2">PIS <br></br>{reg.PIS} <br></br> {reg.PIS_V}</Col>
                                <Col className="col-2">ISS <br></br>{reg.ISS} <br></br> {reg.ISS_V}</Col>
                            </Row>
                        </div>
                    )
                }) }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}

interface iPropsModal {
    show: boolean,
    handleClose: any,
    empresa: any,
    handleModelo: any
    modelos: any[],
}
